
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import Slider from "@/components/SelfSlider.vue";
export default {
  components: {
    Slider,
  },
  setup() {
    const animalIndex = ref<number>(0);
    const tabs = ref<any>([
      {
        lable: "传统电商",
        checked: true,
      },
      {
        lable: "社交电商",
        checked: false,
      },
      {
        lable: "短视频",
        checked: false,
      },
      {
        lable: "直播",
        checked: false,
      },
      {
        lable: "O2O",
        checked: false,
      },
    ]);
    const dimensionList = ref([
      "市场规模",
      "品牌表现",
      "产品系列",
      "单品爆款",
      "销售额",
      "销售量",
      "市场份额",
      "价格变化",
    ]);

    const reportList = ref(["每月报告", "每季报告", "每年报告"]);

    const monitoringList = ref([
      {
        name: "母婴",
        children: [
          "婴幼儿奶粉",
          "儿童食品",
          "纸尿裤",
          "孕妇营养品",
          "儿童护理",
          "玩具",
        ],
      },
      {
        name: "美妆",
        children: [
          "彩妆",
          "护肤品",
          "头发护理",
          "身体护理",
          "香水",
          "美容仪器",
        ],
      },
      {
        name: "百货食品",
        children: ["面粉", "食用油", "巧克力", "糖果", "饼干", "鸡精"],
      },
      {
        name: "口腔护理",
        children: ["牙膏", "牙刷", "水牙线", "电动牙刷", "牙线", "牙粉"],
      },
      {
        name: "医药保健",
        children: [
          "鱼油",
          "维生素",
          "益生菌",
          "药用洗发水",
          "肠胃用药",
          "眼科用药",
        ],
      },
      {
        name: "居家用品",
        children: [
          "滤水设备",
          "织物护理",
          "消毒湿巾",
          "驱虫驱蚊",
          "地板清洁",
          "厨房清洁",
        ],
      },
      {
        name: "酒水饮料",
        children: ["洋酒", "葡萄酒", "啤酒", "白奶", "即饮茶", "含乳饮料"],
      },
      {
        name: "更多...",
        children: [],
      },
    ]);
    const handleTab = (tab: any) => {
      tabs.value.forEach((item: any) => {
        item.checked = item.lable === tab.lable ? true : false;
      });
    };

    onMounted(() => {
      window.addEventListener("scroll", () => {
        const top =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (top > 10) {
          animalIndex.value = animalIndex.value > 0 ? animalIndex.value : 1;
        }
        if (top > 620) {
          animalIndex.value = animalIndex.value > 1 ? animalIndex.value : 2;
        }
        if (top > 1244) {
          animalIndex.value = 3;
        }
      });
    });
    const showModal = () => {
      document.dispatchEvent(new CustomEvent("show_modal", { detail: 1 }));
    };
    return {
      animalIndex,
      tabs,
      handleTab,
      dimensionList,
      reportList,
      monitoringList,
      showModal,
    };
  },
};
